// src/Layout.js
import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useAuth } from "../Components/AuthContext"; // adjust path as needed
import { logoutUser } from "../Components/Authservice.ts";


export default function Layout() {
  const { user } = useAuth();
  const isLoggedIn = !!user;
  return (
    <>
      <header className="navbar">
        <div className="logo">Ani<span className="highlight">Spark</span></div>
        <nav className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/explore">Explore</Link>
          <Link to="/upload">Upload</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </nav>
        
        <div className="auth-buttons">
  {user ? (
    <>
      <span className="welcome-text">Welcome, {user.email}</span>
      <button onClick={logoutUser} className="login">Log Out</button>
    </>
  ) : (
    <>
      <Link to="/login" className="auth-button login">Login</Link>
      <Link to="/signup" className="auth-button signup">Sign Up</Link>
    </>
  )}
</div>

      </header>
      <Outlet />
    </>
  );
}